<script>
import a from '@/assets/full-screen.svg'
import b from '@/assets/end-full-screen.svg'
export default {
  name: "full-screen",
  data() {
    return {
      isFullscreen: false,
    }
  },
  computed: {
    img() {
      return this.isFullscreen ? b : a
    }
  },
  methods: {
    handleClick() {
      // 切换全屏
      if (!this.isFullscreen) {
        // 进入全屏模式
        const element = document.body;
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen(); // Firefox
        } else if (element.webkitRequestFullscreen) {
          element.webkitRequestFullscreen(); // Chrome, Safari
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen(); // IE/Edge
        }
        this.isFullscreen = true;
      } else {
        // 退出全屏模式
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen(); // Firefox
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen(); // Chrome, Safari
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen(); // IE/Edge
        }
        this.isFullscreen = false;
      }
    }
  }
}
</script>

<template>
  <div class="full-screen" @click="handleClick">
    <img :src="img" alt="">
<!--    <el-icon class="el-icon-full-screen"></el-icon>-->
  </div>
</template>

<style scoped lang="scss">
.full-screen {
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
}
.el-icon-full-screen{
  font-size: 30px;
  color: #fff;
}
img{
  width: 30px;
  height: 30px;
}
</style>
